const mediaData = [
  {
    title: '某顶流男星恋情实锤全程回顾',
    duration: '15:28',
    views: '128万次观看',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20romantic%20drama%20visual%20with%20warm%20coral%20pink%20gradients%2C%20soft%20geometric%20heart%20shapes%2C%20cinematic%20lighting%20effect%2C%20editorial%20magazine%20style%2C%20minimal%20composition&width=700&height=450&seq=media-card-01&orientation=landscape',
  },
  {
    title: '网红翻车名场面合辑笑到肚子疼',
    duration: '22:10',
    views: '96万次观看',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20funny%20compilation%20concept%20with%20warm%20orange%20and%20amber%20gradients%2C%20playful%20pop%20art%20geometric%20shapes%2C%20bold%20colors%2C%20energetic%20editorial%20design&width=700&height=450&seq=media-card-02&orientation=landscape',
  },
  {
    title: '深度扒皮某综艺暗箱操作细节',
    duration: '18:45',
    views: '85万次观看',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20investigative%20journalism%20visual%20with%20deep%20coral%20and%20warm%20rose%20gradients%2C%20magnifying%20glass%20geometric%20motif%2C%20dramatic%20lighting%2C%20clean%20editorial%20composition&width=700&height=450&seq=media-card-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
            <i className="ri-play-circle-line text-background-50 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">精彩视频</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10">51吃瓜、91吃瓜热门视频精选，高清流畅在线观看</p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaData.map((item, i) => (
            <a
              key={i}
              href="#media"
              onClick={(e) => e.preventDefault()}
              className="rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-colors cursor-pointer group block"
            >
              <div className="aspect-[16/10] overflow-hidden bg-background-200 relative">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => { const el = e.currentTarget.parentElement; if (el) el.style.display = 'none'; }}
                />
                <div className="absolute inset-0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
                  <div className="w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-background-50 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-3 right-3 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-foreground-900 text-sm mb-1.5 group-hover:text-primary-600 transition-colors line-clamp-2">{item.title}</h3>
                <span className="text-xs text-foreground-400">{item.views}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}